import  React,{Component} from 'react';
import {Row, Col, Button } from 'react-bootstrap';
import UserContext from '../../context/user-context';
import './UserSummary.css'


class UserSummary extends Component {
    
    render() {
        var userAddress = "";
        var accountNumber = "";
            try {
                userAddress =  sessionStorage.getItem('Address');
                accountNumber= sessionStorage.getItem('AccountNumber');
            }
            catch (e) {

            }
        return (<UserContext.Consumer>
            { context => (
            
                <div>
                    <br/>
                    { (accountNumber != null && accountNumber.length > 0) ? (<Row>
                                    <Col sm = {{offset: 0}}>
                                        <p><strong>Account Number : </strong>{accountNumber.toUpperCase()}</p>
                                    </Col>
                                </Row>) : null
                    }
                
                    <Row className="justify-content-between">
                        <Col  sm = {{ span: 7, offset: 0}}>
                            <p><strong>Address : </strong>{(userAddress === "" || userAddress === null) ? null:userAddress.toUpperCase()}</p>
                            {/* {context.fullAddress} */}
                        </Col>
                        { this.props.showEditButton === true ?
                            <Col md= {{offset: 10}} >
                                <Button variant ='custom' type='submit' onClick={this.props.onEditHandler}  block className="light-grey-button no-margin">Edit</Button>
                            </Col> : null}
                            
                        {this.props.showCreateNewButton === true ?
                            <Col md= {{offset: 9}} >
                                <Button variant ='custom' type='submit' onClick={this.props.onCreateNewRequestHandler}  block className="light-grey-button no-margin new-requestt-button">Submit a New Request</Button>
                            </Col> : null
                         }
                    
                    </Row>

                    <br/>
                    <Row>
                        <Col> 
                            <p className="horizontal-line no-padding"/>
                        </Col>
                    </Row>
                 </div>
            )}
            </UserContext.Consumer>
        )}
   
};

export default UserSummary; 